import angular, { IFilterService } from 'angular';

CurrencyIfNumberFilter.$inject = ['$filter'];

export function CurrencyIfNumberFilter($filter: IFilterService) {
  const filterCurrency = $filter('currency');

  function basePriceFilter(rawValue: string | number | null | undefined) {

    if (rawValue == null) {
      return null;
    }

    const normalizedBasePrice = rawValue === '' ? null : rawValue;

    if (normalizedBasePrice === null) {
      return null;
    }

    if (isNaN(Number(normalizedBasePrice))) {
      return rawValue;
    }

    const value = Number(rawValue);

    return filterCurrency(value);
  }

  return basePriceFilter;
}

export const CurrencyIfNumberFilterModule = angular
  .module('acme.common.filter.currencyIfNumber', [])
  .filter('currencyIfNumber', CurrencyIfNumberFilter).name;